import styled from 'styled-components';

import { ZoneIcon, Ellipsis } from 'libs/ui';
import { Checkbox } from '../styled';
import { MultiInput } from './multi-input';

const ValueContent = styled.ul`
  overflow: hidden;
  display: flex;
  align-items: center;
  height: 100%;
  li {
    list-style: none;
    position: relative;
    flex-shrink: 0;
    &:first-child {
      z-index: 8;
      left: 0px;
    }
    &:nth-child(2) {
      z-index: 7;
      left: -20px;
    }
    &:nth-child(3) {
      z-index: 6;
      left: -40px;
    }
    &:nth-child(4) {
      z-index: 5;
      left: -60px;
    }
    &:nth-child(5) {
      z-index: 4;
      left: -80px;
    }
    &:nth-child(6) {
      z-index: 3;
      left: -100px;
    }
    &:nth-child(7) {
      z-index: 2;
      left: -120px;
    }
    &:nth-child(8) {
      z-index: 1;
      left: -140px;
    }
  }
`;

const Value = ({ values, maxValues }) => {
  const getValue = () => {
    const out = [];

    const cnt = values.length;
    for (let i = 0; i < cnt; i++) {
      const item = values[i];
      if (i >= maxValues) {
        out.push(<Ellipsis key="ellipsis">...</Ellipsis>);
        break;
      }
      out.push(
        <ZoneIcon key={item.id} {...item}>
          {item.name}
        </ZoneIcon>
      );
    }
    return out;
  };

  const valueEl = getValue();
  return <ValueContent>{valueEl}</ValueContent>;
};

const Item = (props) => {
  const { onChange, name, checked, ...rest } = props;

  return (
    <Checkbox className="checkbox">
      <input onChange={onChange} type="checkbox" name={name} checked={checked} />
      <ZoneIcon {...rest}>{name}</ZoneIcon>
    </Checkbox>
  );
};

/**
 * data - {id: string, name: string, ...}
 */
export const ZoneInput = (props) => {
  return <MultiInput {...props} itemCmp={Item} valueCmp={Value} className="width-auto" />;
};
